// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"112":"80ecfbac","178":"cab33125","186":"0c7d67af","380":"02f32b7f","440":"7d420a3f","692":"473caa6e","724":"ecbe032e","728":"35bdbf19","794":"8d4c50a8","832":"140bf284","852":"9a1a5da9","952":"1a171430","960":"dd535112"}[chunkId] + ".chunk.js";
};